import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const BlockSpinner = ({ hasOverlay }) => {
    const stateCss = classNames({
        'has-overlay': hasOverlay
    });

    return (
        <div className={`block-spinner ${stateCss}`}></div>
    );
};

BlockSpinner.propTypes = {
    hasOverlay: PropTypes.bool
};


export default BlockSpinner;
